exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[id^='google-selector-'] > .vs__dropdown-toggle {\n  border-radius: 8px 0 0 8px !important;\n}\n", ""]);

// exports
